module.exports = __webpack_public_path__ + "img/20230608.ef772333.png";